module.exports = __webpack_public_path__ + "img/VND.45f1bff9.svg";